import { render, staticRenderFns } from "./RowsPerPage.vue?vue&type=template&id=6bbb6203&"
import script from "./RowsPerPage.vue?vue&type=script&lang=ts&"
export * from "./RowsPerPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports